import { DocumentReference } from '@dsivd/prestations-ng';

import { CadorReference } from './cador-reference';

export class CadorDocumentReference {
    documentReference: DocumentReference[] = [];
    cadorDocumentType: CadorReference;

    constructor(documentReference: DocumentReference[], cadorDocumentType: CadorReference) {
        this.documentReference = documentReference;
        this.cadorDocumentType = cadorDocumentType;
    }

}
